function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\uF0AD");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Calendar---Events-Calendar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.-Calendar---Filters",
  transform: "translate(-1064.000000, -536.000000)",
  fill: "#5B6C7A",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "7.-Small-Components/7.4-Labels-and-Pills/Pills/Filters/Unselected-Copy-9",
  transform: "translate(1052.000000, 529.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "4.-Icons/Small/Solid/Gray",
  transform: "translate(8.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "4.-Icons/Calendar/12px/Dark",
  transform: "translate(-0.500000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.56031189,15.0607732 L12.5574084,10.0636767 C13.7320959,10.4553155 15.0762241,10.1968169 16.0113873,9.26165375 C16.8801978,8.39282038 17.17621,7.16821392 16.8999045,6.05704103 C16.8473991,5.84541739 16.5825606,5.77368599 16.4283404,5.92790621 L14.6855238,7.67072279 L13.0945928,7.40563248 L12.8295025,5.81470152 L14.5723191,4.07190783 C14.7274777,3.9167492 14.6527022,3.65236842 14.4396595,3.59940529 C13.3291961,3.3242442 12.1064665,3.62073703 11.2385716,4.48838022 C10.3095195,5.41743227 10.0538133,6.76414689 10.4405312,7.93837657 L5.4392232,12.9396845 C4.85351597,13.5253918 4.85351597,14.475066 5.4392232,15.0607732 C6.02493042,15.6464804 6.97460467,15.6464804 7.56031189,15.0607732 Z M6.49999642,14.5624987 C6.18945029,14.5624987 5.93749776,14.3105461 5.93749776,14 C5.93749776,13.689225 6.18945029,13.4375013 6.49999642,13.4375013 C6.81054256,13.4375013 7.06249508,13.689225 7.06249508,14 C7.06249508,14.3105461 6.81054256,14.5624987 6.49999642,14.5624987 Z",
  id: "\\uF0AD"
}))))));

var SvgServiceIcon = function SvgServiceIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgServiceIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ServiceIcon.a3b188c4.svg";
export { ForwardRef as ReactComponent };